// import '@babel/polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import Print from 'vue-print-nb'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Http from './service/http'
import playHttp from './service/playHttp'
import httpJinshui from './service/httpJinshui'
import httpFenYin from './service/httpFenYin'
import httpUpload from './service/httpUpload'
import Common from './publicFunction/common'
// import '@/utils/aegis.js';
import VideoPlayer from 'vue-video-player/src';
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
 
Vue.use(VideoPlayer)


import BaiduMap from 'vue-baidu-map'  //百度地图

import { message } from './publicFunction/resetMessage'

import { TcPlayer } from './publicFunction/TcPlayer-module-2.3.3'

import echarts from 'echarts'
import '../node_modules/echarts/map/js/china.js'  // 引入中国地图数据
import '../node_modules/echarts/map/js/province/beijing.js'  // 引入北京地图数据
import '../node_modules/echarts/map/js/province/henan.js'  // 引入河南地图数据
import TreeTable from 'vue-table-with-tree-grid'
//引入剪切板插件clipboard;
import clickCopy from './assets/js/clickCopy'
import dataV from '@jiaminghi/data-view'
// import world from 'echarts/map/js/world.js'
// import echartsGL from 'echarts-gl' // 引入echarts

// import Es6Promise from 'es6-promise' 
// require('es6-promise').polyfill() 
// Es6Promise.polyfill()

// 把http挂载到Vue实例上（全局都可以用）
Vue.prototype.$Http = Http
Vue.prototype.$playHttp = playHttp
Vue.prototype.$httpJinshui = httpJinshui
Vue.prototype.$httpFenYin = httpFenYin
Vue.prototype.$httpUpload = httpUpload


Vue.use(dataV)
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(router)
Vue.use(Print)
Vue.component('tree-table', TreeTable )
Vue.use(BaiduMap,{
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: store.state.config.baiDuMap.ak
})
Vue.prototype.$store = store
Vue.prototype.$Common = Common
Vue.prototype.$message = message //重写message提示框  一定要放在Vue.use(ElementUI)之后
// Vue.prototype.$router = router

Vue.prototype.echarts = echarts
// Vue.prototype.$echartsGL = echartsGL // 引入组件（将echarts注册为全局）
Vue.prototype.TcPlayer = TcPlayer

//点击复制
Vue.prototype.clickCopy = clickCopy

Vue.config.productionTip = false
// console.log(router.path);

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')

// new MutationObserver((mutationRecords) => {
// 	mutationRecords.forEach((record) => {
// 		console.log(record)
// 		if (record.type === 'childList') {
// 		  // addedNodes 里就是新创建的标签
// 		  record.addedNodes.forEach((node) => {
// 			console.log(node.src)
// 			// 这里过滤出 script 和 rel === 'stylesheet' 的 link 标签。代码略
// 			// const url = isScript ? node.src : node.href // 如果判断 url 存在且合法的话，则可以认为该 url 已经开始发起请求了
// 		  })
// 		}
// 	  })
// 	// 我们在这里监听 script 和 styleLink 标签的动态
//   }).observe(
// 	document.documentElement,
// 	// 如下配置参数除了 attributeFilter 这个为了更好性能的参数，一个都不能动
// 	{
// 	  childList: true,
// 	  subtree: true,
// 	  attributes: true,
// 	  attributeFilter: ['src', 'href'],
// 	  attributeOldValue: true,
// 	},
//   )
